module.exports = __webpack_public_path__ + "static/media/05cheliangjianxiugong.a589161b.png";